var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4648",
    "data-name": "Group 4648",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.758,
    height: 18.683,
    viewBox: "0 0 20.758 18.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1656",
    "data-name": "Rectangle 1656",
    width: 20.758,
    height: 18.683,
    fill: "#ffd6ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4647",
    "data-name": "Group 4647",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14057",
    "data-name": "Path 14057",
    d: "M20.531,3.655A5.2,5.2,0,0,0,15.569,0H5.19A5.2,5.2,0,0,0,.227,3.655,5.486,5.486,0,0,0,0,5.19v8.3a5.191,5.191,0,0,0,5.19,5.19H15.569a5.191,5.191,0,0,0,5.19-5.19V5.19a5.486,5.486,0,0,0-.227-1.535M5.19,2.076H15.569A3.122,3.122,0,0,1,18.64,4.693l-8.26,4.5-8.26-4.5A3.122,3.122,0,0,1,5.19,2.076M18.683,13.493a3.122,3.122,0,0,1-3.114,3.114H5.19a3.122,3.122,0,0,1-3.114-3.114V7.038l7.807,4.254a1.045,1.045,0,0,0,.994,0l7.807-4.254Z",
    fill: "#ffd6ec"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail_icon.3efdb0f10e01625159d6ef0c5f23541b.svg";
export { ForwardRef as ReactComponent };